import React, { Fragment } from 'react';
import { toast } from 'react-toastify';
import {Card,CardBody,CardHeader } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import axios from 'axios';
import {Redirect} from 'react-router';

import '../../assets/scss/app-styles/users.scss'

class Details extends React.Component {

	constructor(props) {
		super(props);
	}

	state = {
		data: {
            transport: "udp",
            expires: "60",
            allow_message: "1",
            outbound_proxy_enabled: "1",
            remote_msg_delete_supported: "1",
            msg_local_delete_supported: "1",
            outgoing_calls_through_sipis: "1",
            ringing_tone: "periodic(sine(2000ms,2500,440Hz),silence(4000ms))",
		},
		backToIndex: false,
        style: 'custom-spinner',
	};
	headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    }

    transportItems = [];

    populateDefaults(){
        axios.get(`${process.env.REACT_APP_API_URL}getDefaults`, this.headers)
            .then(response=>{

                let items = [];

                items = this.populateItems(response.data.transport.Allowed);
                this.transportItems = items;

            })
            .catch(err=>{
                toast.error(err.message);

            }
        );
    }

    populateItems = (data) => {

        let items = [];
        items.push(<option value={""}></option>);
        data.map((row)=>(
            items.push(<option value={row}>{row}</option>)
        ));

        return items;

    }

	inputChangeHandler = (event) => {
		var data = this.state.data;
		data[event.target.name] = event.target.value;
        this.setState({ data });
	}

    getSubscribers = () => {
        const payLoad = {
            user_id: JSON.parse(localStorage.getItem('creds')).id
        }

        axios.post(`${process.env.REACT_APP_API_URL}getCloudIds`, payLoad, this.headers)
        .then(response => {
            let items = [];
            items.push(<option value={""}></option>);
            var data =  this.state.data;
            response.data.map((row)=>{
                if (JSON.parse(localStorage.getItem('creds')).cloud_id !== "CREXDEMO" && row.cloud_id  ===  JSON.parse(localStorage.getItem('creds')).cloud_id){
                    data["cloud_id"] = row.cloud_id;
                    data["subscriber_id"] = row.id;
                    this.setState({data});
                }
                items.push(<option value={row.cloud_id}>{row.cloud_id}</option>)
                return null;
            });
            this.subscribersItems = items;
            this.setState({subscribersItems: items})
        }).catch(err => {
            if (err.response){
                toast.error(err.response.data);
            } else{
                toast.error(err.message);
            }
            this.setState({style: 'custom-spinner-hide'});
        });
    }


	componentDidMount() {
		if(!this.props.location.state){
			this.setState({backToIndex: true});
            this.setState({style: 'custom-spinner-hide'});
			return;
		}
        this.populateDefaults();
        this.getSubscribers();
		if (this.props.location.state.id) {
			this.setState({style: 'custom-spinner'});
			const payLoad = {
				id: this.props.location.state.id,
				user_id: JSON.parse(localStorage.getItem('creds')).id
			};
			axios.post(`${process.env.REACT_APP_API_URL}accountDetail`, payLoad, this.headers)
			.then(response => {
				var data = this.state.data;
				data = response.data;
				this.setState({ data });
				this.setState({style: 'custom-spinner-hide'});
			}).catch(err => {
                if (err.response){
                    toast.error(err.response.data);
                } else{
                    toast.error(err.message);
                }
                this.setState({style: 'custom-spinner-hide'});
			});
		} else {
			this.setState({style: 'custom-spinner-hide'});
		}

	}

	saveHandler = (event) =>{
		event.preventDefault();
		if (!this.state.data.cloud_id || !this.state.data.cloud_username || !this.state.data.cloud_password ||
                !this.state.data.proxy || !this.state.data.outbound_proxy_host || !this.state.data.account_username
            || !this.state.data.account_password) {
            toast.error('Fields with * are mandatory!');
            return;
		}
        if(this.state.data.expires && this.state.data.expires.length > 3){
            toast.error("Expires value can not be greater than 999");
            return;
        }
		this.setState({style: 'custom-spinner'});
		var data = this.state.data;
		this.setState({ data });
		const payLoad = this.state.data;
        payLoad["user_id"] = JSON.parse(localStorage.getItem('creds')).id;
		axios.post(`${process.env.REACT_APP_API_URL}createUpdateAccount`, payLoad, this.headers)
		.then(response => {
			this.setState({ backToSummary: true });
            this.setState({style: 'custom-spinner-hide'});
		}).catch(err => {
            if (err.response){
                toast.error(err.response.data);
            } else{
                toast.error(err.message);
            }
            this.setState({style: 'custom-spinner-hide'});
		});
	}

	cancelHandler = () => {
		this.setState({ backToSummary: true });
	}

	render() {

		let redirect = null;
		if (this.state.backToSummary) {
			this.setState({ backToSummary: false });
			redirect = <Redirect to={{
				pathname: '/static_accounts',
			}}/>;
		}
		if(this.state.backToIndex){
			redirect = <Redirect to = {{
				pathname: "/dashboard"
			}} />;
		}

		return (
            <Fragment>
                {redirect}
                <Breadcrumb parent="Static Accounts" title="Details" />
                <div className={"loader-box " + this.state.style} >
                    <div className="loader">
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    </div>
                </div>
                <div className="container-fluid main-container">
                    <div className="col-md-2 col-sm-0"></div>
                    <Card className="col-md-8 col-sm-12">
                        <CardHeader>
                            <h5>{this.props.location.state && this.props.location.state.id? "Edit Account" : "Add Account"}</h5>
                        </CardHeader>
                        <CardBody className="dropdown-basic">
                            <div className="row form-group">
                                {
                                    JSON.parse(localStorage.getItem('creds')).cloud_id === "CREXDEMO" && this.state.subscribersItems? 
                                        <div className="col-md-6">
                                            <label> Subscriber  </label> <span> * </span>
                                            <select  className="form-control"
                                                onChange={this.inputChangeHandler} name="cloud_id" 
                                                value={this.state.data.cloud_id}>
                                                {this.state.subscribersItems}
                                            </select>
                                        </div>
                                    : null
                                }

                                <div className="col-md-6">
                                    <label className="float-left"> 
                                        Transport  
                                    </label> <span> * </span>
                                    <select  className="form-control"
                                        onChange={this.inputChangeHandler} name="transport" 
                                        value={this.state.data.transport}>
                                        {this.transportItems}
                                    </select>
                                </div>
                                
                            </div>

                            <div className="row form-group">
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Subscriber Login
                                    </label> <span> * </span>
                                    <input type="text" className="form-control" name="cloud_username"
                                        onChange={this.inputChangeHandler} value={this.state.data.cloud_username}/>
                                </div>
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Subscriber Password
                                    </label> <span> * </span>
                                    <input type="password" className="form-control" name="cloud_password"
                                        onChange={this.inputChangeHandler} value={this.state.data.cloud_password}/>
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Proxy
                                    </label> <span> * </span>
                                    <input type="text" className="form-control" name="proxy"
                                        onChange={this.inputChangeHandler} value={this.state.data.proxy}/>
                                </div>
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Outbound Proxy Host
                                    </label> <span> * </span>
                                    <input type="text" className="form-control" name="outbound_proxy_host"
                                        onChange={this.inputChangeHandler} value={this.state.data.outbound_proxy_host}/>
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Username
                                    </label> <span> * </span>
                                    <input type="text" className="form-control" name="account_username"
                                        onChange={this.inputChangeHandler} value={this.state.data.account_username}/>
                                </div>
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Password
                                    </label> <span> * </span>
                                    <input type="password" className="form-control" name="account_password"
                                        onChange={this.inputChangeHandler} value={this.state.data.account_password}/>
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-md-6">
                                    <label className="float-left">
                                        Expires
                                    </label>
                                    <input type="number" className="form-control" name="expires"
                                        onChange={this.inputChangeHandler} value={this.state.data.expires}/>
                                </div>
                                <div className="col-md-6 custom-radio">
                                    <label> Allow Message  </label>
                                    <div onChange={this.inputChangeHandler}>
                                        <input className="margin-left-10"
                                            type="radio" value="1" name="allow_message"
                                            checked={this.state.data.allow_message === "1"}
                                            /> Yes
                                        <input className="margin-left-10"
                                            type="radio" value="0" name="allow_message"
                                            checked={this.state.data.allow_message === "0"}/> No
                                    </div>
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-md-6 custom-radio">
                                    <label> Outbound Proxy Enabled  </label>
                                    <div onChange={this.inputChangeHandler}>
                                        <input className="margin-left-10"
                                            type="radio" value="1" name="outbound_proxy_enabled"
                                            checked={this.state.data.outbound_proxy_enabled === "1"}
                                            /> Yes
                                        <input className="margin-left-10"
                                            type="radio" value="0" name="outbound_proxy_enabled"
                                            checked={this.state.data.outbound_proxy_enabled === "0"}/> No
                                    </div>
                                </div>
                                <div className="col-md-6 custom-radio">
                                    <label> Remote Message Delete Supported  </label>
                                    <div onChange={this.inputChangeHandler}>
                                        <input className="margin-left-10"
                                            type="radio" value="1" name="remote_msg_delete_supported"
                                            checked={this.state.data.remote_msg_delete_supported === "1"}
                                            /> Yes
                                        <input className="margin-left-10"
                                            type="radio" value="0" name="remote_msg_delete_supported"
                                            checked={this.state.data.remote_msg_delete_supported === "0"}/> No
                                    </div>
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-md-6 custom-radio">
                                    <label> Msg Local Delete Supported  </label>
                                    <div onChange={this.inputChangeHandler}>
                                        <input className="margin-left-10"
                                            type="radio" value="1" name="msg_local_delete_supported"
                                            checked={this.state.data.msg_local_delete_supported === "1"}
                                            /> Yes
                                        <input className="margin-left-10"
                                            type="radio" value="0" name="msg_local_delete_supported"
                                            checked={this.state.data.msg_local_delete_supported === "0"}/> No
                                    </div>
                                </div>
                                <div className="col-md-6 custom-radio">
                                    <label> Outgoing Calls Through SIPIS  </label>
                                    <div onChange={this.inputChangeHandler}>
                                        <input className="margin-left-10"
                                            type="radio" value="1" name="outgoing_calls_through_sipis"
                                            checked={this.state.data.outgoing_calls_through_sipis === "1"}
                                            /> Yes
                                        <input className="margin-left-10"
                                            type="radio" value="0" name="outgoing_calls_through_sipis"
                                            checked={this.state.data.outgoing_calls_through_sipis === "0"}/> No
                                    </div>
                                </div>
                            </div>

                            <div className="row form-group">

                                <div className="col-md-12">
                                    <label className="float-left"> RingingTone  </label> <span> * </span>
                                    <input type="text" className="form-control" name="ringing_tone"
                                    onChange={this.inputChangeHandler}
                                    value = {this.state.data.ringing_tone}/>
                                </div>

                            </div>

                            <div className="row form-group">
                                <div className="col-md-12">

                                    <button type="button" onClick={this.cancelHandler} className="button-custom btn shadow-2 btn-secondary btn-width">
                                        CANCEL
                                    </button>
                                    <button type="button" onClick={this.saveHandler} className="button-custom btn shadow-2 btn-success btn-width">
                                        SAVE
                                    </button>

                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <div className="col-md-2 col-sm-0"></div>
                </div>
            </Fragment>
		);

	}
}

export default Details;
